import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Row, Col, Card, Popover, Button, Divider, message, Spin } from 'antd';
import SubnavBar from '../subnav_bar/SubnavBar';
import {
	nullSafeGet,
	nullSafeGetOrElse,
	getStartDateFieldName,
	getEndDateFieldName,
	getEntitiesByIdWithSearch,
	isSupplierPayingCustomer,
} from '../../utils/DataAccessUtils';
import { workOrderPrioritiesRestCrudThunksForSupplier } from '../../thunks/work_order_priorities_thunks';
import { fieldTechsRestCrudThunksForSupplier } from '../../thunks/field_techs_thunks';
import { assetTypesRestCrudThunksForSupplier } from '../../thunks/asset_types_thunks';
import { resolutionTypesRestCrudThunksForSupplier } from '../../thunks/resolution_types_thunks';
import { plannedMaintenanceSchedulesRestCrudThunksForSupplier } from '../../thunks/planned_maintenance_schedules_thunks';
import { assetsRestCrudThunksForSupplier } from '../../thunks/assets_thunks';
import { ContractorPrivateNetworksRestCrudThunksForSupplier } from '../../thunks/contractors_private_networks_thunks';
import { fetchDistinctAreasHeirarchy } from '../../thunks/areas_thunks';
import { contractorClientsRestCrudThunksForSupplier } from '../../thunks/contractor_clients_thunks';
import { contractorLocationsRestCrudThunksForSupplier } from '../../thunks/contractor_locations_thunks';
import { problemTypesHeirarchicalForSupplier } from '../../thunks/problem_types_thunks';
import { fetchSupplierFacilitiesInPrivateNetworkForSupplier } from '../../thunks/supplier_facilities_thunks';
import { spendCategoriesRestCrudThunksForSupplier } from '../../thunks/spend_categories_thunks';
import { contactsRestCrudThunksForSupplierForThirdPartySuppliers } from '../../thunks/contacts_thunks';
import EventCalendar from '../event_calendar/EventCalendar';
import {
	capitalize,
	formatDateForParam,
	encodeUTCAdjustedDate,
	isDatePastDue,
	formatDateForLocationTimeZone,
	convertInstantToTimeZoneMoment,
} from '../../utils/DataFormatterUtils';
import moment from 'moment';
import { ServiceCallPopoverDisplayV2 } from '../service_call_popover_display/ServiceCallPopoverDisplayV2';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import SelectedFilters from '../selected_filters_pills/SelectedFilters';
import { FILTER_CONFIG_NAMES } from '../../utils/DataConstants';
import {
	fetchWorkOrders,
	updateFiltersWorkOrders,
	clearFiltersWorkOrders,
} from '../../thunks/work_orders_thunks_wrapper';
import {
	rescheduleServiceCallForSupplier,
	workOrdersRestCrudThunksForSupplier,
} from '../../thunks/work_orders_thunks';
import {
	getSanitisedWorkOrder,
	getWorkOrderArchivalKey,
	INTERNAL_SERVICE_TEAM_WO_FILTERS_ORDER,
	isAValidAndParitalWorkOrder,
	PAYING_SUPPLIER_WO_FILTER_ORDER,
	THIRD_PARTY_SUPPLIER_WO_FILTERS_ORDER,
} from '../../utils/WorkOrderUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { Views } from 'react-big-calendar';
import { PipelineFilter } from '../WorkOrderTable/pipelineFilters/pipelineFilters';
import {
	morePipelineFiltersSupplier,
	pipelineFiltersSupplierCalendar,
} from '../WorkOrderTable/config/pipelineFilters/pipelineFilters';
import AssignedFilters from '../WorkOrderTable/AssignedFilters';
import SubContractedFilters from '../WorkOrderTable/SubContractedFilters';
import { ASSIGNED_FILTERS } from '../WorkOrderTable/config/assigned';
import { SUBCONTRACTED_FILTERS } from '../WorkOrderTable/config/subcontracted';
import { Select } from 'antd';
import WorkOrderTable from '../WorkOrderTable';
import { CaretDownFilled, CloseOutlined } from '@ant-design/icons';
import { Sorter } from '../WorkOrderTable/sorters/Sorters';
import { WORK_ORDER_SORTERS } from '../WorkOrderTable/config/sorters/sorters';
import ServiceCalendarWorkOrderRow from './ServiceCalendarWorkOrderRow';
import {
	useCommonFilterConfiguration,
	useSupplierFilterConfiguration,
} from '../../hooks/workOrderHooks';
import { brandsRestCrudThunksForSupplier } from '../../thunks/brands_thunks';
import { EmptyState } from '../empty_state/EmptyState';
import ScheduleServiceCallModalForm from '../schedule_service_call_modal_form/ScheduleServiceCallModalForm';
import OWSearchInput from '../common/OWSearchInput';
import { withCurrentUser } from '../../hooks/withCurrentUser';
import { WORK_ORDER_DISPLAY_STATUSES } from '../../constants/WorkOrderDisplayStatuses';
import { withUserType } from '../withUserType';
import { WORK_ORDER_STATUSES } from '../../constants/WorkOrderStatuses';
import Filters from '../WorkOrderTable/filters/filters';
import { isInternalTech } from '../../utils/AuthUtils';

const { Content } = Layout;
const WORK_ORDERS_CALENDAR_TARGET_COLLECTION = 'workOrdersCalendarIndex';
const WORK_ORDERS_SCHEDULE_TARGET_COLLECTION = 'workOrdersScheduleIndex';
const LAST_SERVICE_CALL_SCHEDULED_AT_FIELD = FILTER_CONFIG_NAMES.LAST_SERVICE_CALL_SCHEDULED_AT;
const FOUR_DAY_WEEK = 'four_day_week';

const calculateDateRangeForView = (view, date) => {
	let startDate, endDate;

	if (view === Views.DAY) {
		const dayStart = moment(date).startOf('day');
		const dayEnd = moment(date).endOf('day');
		startDate = formatDateForParam(encodeUTCAdjustedDate(dayStart));
		endDate = formatDateForParam(encodeUTCAdjustedDate(dayEnd, true));
	} else if (view === Views.WEEK) {
		const mondayStart = moment(date).startOf('week').isoWeekday(1).startOf('day');
		const sundayEnd = moment(date).endOf('week').isoWeekday(7).endOf('day');
		startDate = formatDateForParam(encodeUTCAdjustedDate(mondayStart));
		endDate = formatDateForParam(encodeUTCAdjustedDate(sundayEnd, true));
	} else if (view === FOUR_DAY_WEEK) {
		const rangeStart = moment(date).startOf('day');
		const rangeEnd = rangeStart.clone().add(3, 'days').endOf('day');
		startDate = formatDateForParam(encodeUTCAdjustedDate(rangeStart));
		endDate = formatDateForParam(encodeUTCAdjustedDate(rangeEnd, true));
	} else {
		// Fallback to day view
		const dayStart = moment(date).startOf('day');
		const dayEnd = moment(date).endOf('day');
		startDate = formatDateForParam(encodeUTCAdjustedDate(dayStart));
		endDate = formatDateForParam(encodeUTCAdjustedDate(dayEnd, true));
	}

	return { startDate, endDate };
};

require('./SupplierServiceCallCalendarPage.less');

const Week = require('react-big-calendar/lib/Week').default;
const TimeGrid = require('react-big-calendar/lib/TimeGrid').default;
const constants = require('react-big-calendar/lib/utils/constants');

class FourDayWeekView extends Week {
	static range(date, { localizer }) {
		// Start from the given date and show 4 consecutive days
		const start = moment(date).startOf('day');
		const days = [];
		// Return exactly 4 consecutive days starting from the given date
		for (let i = 0; i < 4; i++) {
			days.push(start.clone().add(i, 'days').toDate());
		}
		return days;
	}

	static navigate(date, action, { localizer }) {
		const currentDate = moment(date);
		switch (action) {
			case constants.navigate.PREVIOUS:
				// Move back by 1 day
				return currentDate.subtract(1, 'day').toDate();
			case constants.navigate.NEXT:
				// Move forward by 1 day
				return currentDate.add(1, 'day').toDate();
			case constants.navigate.TODAY:
				return moment().toDate();
			default:
				return date;
		}
	}

	static title(date, { localizer }) {
		const range = FourDayWeekView.range(date, { localizer });
		const start = moment(range[0]);
		const end = moment(range[range.length - 1]);
		return localizer.format({ start, end }, 'dayRangeHeaderFormat');
	}

	render() {
		const {
			date,
			localizer,
			min = localizer.startOf(new Date(), 'day'),
			max = localizer.endOf(new Date(), 'day'),
			scrollToTime = localizer.startOf(new Date(), 'day'),
			enableAutoScroll = true,
			...props
		} = this.props;
		// Use our custom range method instead of the parent's
		const range = FourDayWeekView.range(date, { localizer });
		return React.createElement(
			TimeGrid,
			Object.assign({}, props, {
				range: range,
				eventOffset: 15,
				localizer: localizer,
				min: min,
				max: max,
				scrollToTime: scrollToTime,
				enableAutoScroll: enableAutoScroll,
			})
		);
	}
}

// Technician Filter Component
const TechnicianFilter = ({
	value,
	onChange,
	fieldTechs,
	fetchFieldTechs,
	fetchMultipleFieldTechs,
}) => {
	const selectedEmail = nullSafeGet('fieldTechnicianEmail', value || {});

	return (
		<OWAsyncSelect
			stateSlice={fieldTechs}
			valueAccessor={(el) => el.email}
			allowClear={true}
			placeholder="Select Technician"
			value={selectedEmail}
			targetCollectionName="workOrdersAdvancedFilters"
			fetchData={(
				searchText,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			) => {
				fetchFieldTechs(
					{ search: searchText && searchText.trim() },
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				);
			}}
			fetchMultiple={(ids, targetCollectionName) => {
				fetchMultipleFieldTechs(ids, targetCollectionName);
			}}
			renderRecord={(ft) => (
				<Select.Option key={ft.email} value={ft.email}>
					{ft.name}
				</Select.Option>
			)}
			onChange={(email) => {
				onChange({ fieldTechnicianEmail: email || undefined });
			}}
			sortBy={{
				sort_by: 'name',
				order: 'ascend',
			}}
			style={{ minWidth: 200 }}
		/>
	);
};

const SupplierServiceCallCalendarPageV2 = (props: any) => {
	const {
		workOrders,
		data,
		fetchData,
		updateFilters,
		clearFilters,
		fetchLocations,
		fetchWorkOrderPriorities,
		fetchMultipleFieldTechs,
		fetchFieldTechs,
		locations,
		workOrderPriorities,
		fieldTechs,
		location,
		currentUser,
		spendCategories,
		fetchSpendCategories,
		fetchMultipleSpendCategories,
		contractorPrivateNetworks,
		fetchContractors,
		contractorClients,
		fetchContractorClients,
		fetchMultipleContractorClients,
		contractorLocations,
		fetchContractorLocations,
		fetchMultipleContractorLocations,
		users,
		fetchUsers,
		fetchMultipleUsers,
		areas,
		fetchAreasDistinct,
		assets,
		fetchAssets,
		fetchMultipleAssets,
		assetTypes,
		fetchAssetTypes,
		fetchMultipleAssetTypes,
		planned_maintenance_schedules,
		fetchPMSchedule,
		fetchMultiplePMSchedule,
		problemTypes,
		fetchProblemTypes,
		supplierFacilities,
		fetchSupplierFacilitiesInPrivateNetwork,
		resolutionTypes,
		fetchResolutionTypes,
		fetchMultipleResolutionTypes,
		companyConfig,
		rescheduleServiceCall,
		getFullWorkOrder,
		syncScheduleTechnicianFilter,
	} = props;

	const { fetching, pagination } = workOrders;

	const [showScheduleWOs, setShowScheduleWOs] = useState(false);
	const [rescheduleModalVisible, setRescheduleModalVisible] = useState(false);
	const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
	const [newScheduledTime, setNewScheduledTime] = useState(null);
	const [isLoadingFullWorkOrder, setIsLoadingFullWorkOrder] = useState(false);
	const [calendarDate, setCalendarDate] = useState(new Date());
	const [calendarView, setCalendarView] = useState(Views.DAY);
	const [scrollToTime, setScrollToTime] = useState(new Date());
	const rescheduleFormRef = useRef(null);

	// Calculate staleDays from companyConfig
	const staleDays = useMemo(
		() => nullSafeGetOrElse('config.workOrder.stale.afterXDays', companyConfig, 14),
		[companyConfig]
	);

	useEffect(() => {
		fetchData(location, calendarDate, calendarView);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleClearAndUpdateFilters = () => {
		const startDateFieldName = getStartDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);
		const endDateFieldName = getEndDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);

		const startDate = nullSafeGet(`filters.${startDateFieldName}`, workOrders);
		const endDate = nullSafeGet(`filters.${endDateFieldName}`, workOrders);

		clearFilters({
			[startDateFieldName]: startDate,
			[endDateFieldName]: endDate,
		});
	};

	// Helper function to update date filters based on view and date
	const updateDateFiltersForView = useCallback(
		(view, date) => {
			const startDateFieldName = getStartDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);
			const endDateFieldName = getEndDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);
			const { startDate, endDate } = calculateDateRangeForView(view, date);

			if (startDate && endDate) {
				updateFilters({
					[startDateFieldName]: startDate,
					[endDateFieldName]: endDate,
				});
			}
		},
		[updateFilters]
	);

	const handleRangeChange = (range, view) => {
		const startDateFieldName = getStartDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);
		const endDateFieldName = getEndDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);

		// Use the view parameter if provided, otherwise fall back to calendarView state
		const currentView = view || calendarView;
		let startDate, endDate;

		if (currentView === Views.DAY) {
			// Day view: 12:00am to 11:59:59pm of that day
			// Range is typically an array with one date
			const dayDate =
				Array.isArray(range) && range.length > 0
					? moment(range[0])
					: range.start
					? moment(range.start)
					: moment(calendarDate);
			startDate = formatDateForParam(encodeUTCAdjustedDate(dayDate.clone().startOf('day')));
			endDate = formatDateForParam(encodeUTCAdjustedDate(dayDate.clone().endOf('day'), true));
		} else if (currentView === Views.WEEK) {
			// Week view: Monday 12:00am to Sunday 11:59:59pm
			// Range is typically an array of dates for the week (7 dates)
			if (Array.isArray(range) && range.length > 0) {
				// Use the first and last dates in the range array to get the week boundaries
				const firstDate = moment(range[0]);
				const lastDate = moment(range[range.length - 1]);
				// Ensure we get Monday start and Sunday end
				const mondayStart = firstDate.clone().startOf('week').isoWeekday(1).startOf('day');
				const sundayEnd = lastDate.clone().endOf('week').isoWeekday(7).endOf('day');
				startDate = formatDateForParam(encodeUTCAdjustedDate(mondayStart));
				endDate = formatDateForParam(encodeUTCAdjustedDate(sundayEnd, true));
			} else if (range.start && range.end) {
				// If range is an object with start/end, use those boundaries
				const mondayStart = moment(range.start).startOf('week').isoWeekday(1).startOf('day');
				const sundayEnd = moment(range.end).endOf('week').isoWeekday(7).endOf('day');
				startDate = formatDateForParam(encodeUTCAdjustedDate(mondayStart));
				endDate = formatDateForParam(encodeUTCAdjustedDate(sundayEnd, true));
			} else {
				// Fallback: calculate from calendarDate
				const weekStartDate = moment(calendarDate);
				const mondayStart = weekStartDate.clone().startOf('week').isoWeekday(1).startOf('day');
				const sundayEnd = weekStartDate.clone().endOf('week').isoWeekday(7).endOf('day');
				startDate = formatDateForParam(encodeUTCAdjustedDate(mondayStart));
				endDate = formatDateForParam(encodeUTCAdjustedDate(sundayEnd, true));
			}
		} else if (currentView === FOUR_DAY_WEEK) {
			if (Array.isArray(range) && range.length > 0) {
				const firstDate = moment(range[0]);
				const lastDate = moment(range[range.length - 1]);
				const rangeStart = firstDate.clone().startOf('day');
				const rangeEnd = lastDate.clone().endOf('day');
				startDate = formatDateForParam(encodeUTCAdjustedDate(rangeStart));
				endDate = formatDateForParam(encodeUTCAdjustedDate(rangeEnd, true));
			} else if (range.start && range.end) {
				const rangeStart = moment(range.start).startOf('day');
				const rangeEnd = moment(range.end).endOf('day');
				startDate = formatDateForParam(encodeUTCAdjustedDate(rangeStart));
				endDate = formatDateForParam(encodeUTCAdjustedDate(rangeEnd, true));
			} else {
				const rangeStart = moment(calendarDate).startOf('day');
				const rangeEnd = rangeStart.clone().add(3, 'days').endOf('day');
				startDate = formatDateForParam(encodeUTCAdjustedDate(rangeStart));
				endDate = formatDateForParam(encodeUTCAdjustedDate(rangeEnd, true));
			}
		} else {
			// Fallback to original logic for other views
			if (Array.isArray(range)) {
				if (range.length === 1) {
					startDate = formatDateForParam(
						encodeUTCAdjustedDate(moment(range[0]).subtract(1, 'day'))
					);
					endDate = formatDateForParam(encodeUTCAdjustedDate(moment(range[0]).add(1, 'day'), true));
				} else {
					startDate = formatDateForParam(encodeUTCAdjustedDate(moment(range[0])));
					endDate = formatDateForParam(
						encodeUTCAdjustedDate(moment(range[range.length - 1]), true)
					);
				}
			} else if (range.start && range.end) {
				startDate = formatDateForParam(encodeUTCAdjustedDate(moment(range.start)));
				endDate = formatDateForParam(encodeUTCAdjustedDate(moment(range.end), true));
			}
		}

		if (startDate && endDate) {
			updateFilters({
				[startDateFieldName]: startDate,
				[endDateFieldName]: endDate,
			});
		}
	};

	const handleEventDrop = async ({ event, start, end }) => {
		// Only allow rescheduling for scheduled work orders
		if (
			event.eventStatus !== 'Scheduled' &&
			event.eventStatus !== 'PastDue' &&
			event.eventStatus !== 'OnHold'
		) {
			message.warning('Only scheduled work orders can be rescheduled.');
			return;
		}

		// Sanitize the work order first
		const sanitizedWorkOrder = getSanitisedWorkOrder(event, true);

		// Fetch full work order if needed
		let fullWorkOrder = sanitizedWorkOrder;
		if (isAValidAndParitalWorkOrder(sanitizedWorkOrder)) {
			if (isLoadingFullWorkOrder) {
				return;
			}

			setIsLoadingFullWorkOrder(true);
			const hideLoading = message.loading('Loading work order details...', 0);
			try {
				const fetchedWorkOrder = await getFullWorkOrder(sanitizedWorkOrder.id);
				fullWorkOrder = getSanitisedWorkOrder(fetchedWorkOrder, true);
				hideLoading();
			} catch (error) {
				hideLoading();
				message.error('Failed to load work order details. Please try again.');
				setIsLoadingFullWorkOrder(false);
				return;
			} finally {
				setIsLoadingFullWorkOrder(false);
			}
		}

		// Set the selected work order and new scheduled time
		setSelectedWorkOrder(fullWorkOrder);
		setNewScheduledTime(start);
		setRescheduleModalVisible(true);
	};

	const handleRescheduleSubmit = () => {
		if (!rescheduleFormRef.current || !rescheduleFormRef.current.props) {
			return;
		}

		const form = rescheduleFormRef.current.props.form;
		if (!form) {
			return;
		}

		form.validateFields((err, values) => {
			if (err) {
				return;
			}
			const timeZone =
				values['serviceScheduledAtTimeZone'] ||
				nullSafeGet('location.timeZoneId', selectedWorkOrder);
			const lastServiceCall = nullSafeGetOrElse('lastServiceCall', selectedWorkOrder, {});
			const formData = {
				...lastServiceCall,
				...values,
				serviceScheduledAt: formatDateForLocationTimeZone(values.serviceScheduledAt, timeZone),
				workOrderId: nullSafeGet('id', selectedWorkOrder),
			};

			rescheduleServiceCall(formData)
				.then(() => {
					setRescheduleModalVisible(false);
					// Move calendar to the rescheduled time
					let newDate = calendarDate;
					if (values.serviceScheduledAt) {
						const scheduledMoment = moment(values.serviceScheduledAt);
						if (scheduledMoment.isValid()) {
							const scheduledDate = scheduledMoment.toDate();
							setCalendarDate(scheduledDate);
							setScrollToTime(scheduledDate);
							newDate = scheduledDate;
						}
					} else if (newScheduledTime) {
						const scheduledDate = new Date(newScheduledTime);
						setCalendarDate(scheduledDate);
						setScrollToTime(scheduledDate);
						newDate = scheduledDate;
					}
					setSelectedWorkOrder(null);
					setNewScheduledTime(null);
					fetchData(location, newDate, calendarView);
					message.success('Service call rescheduled.');
				})
				.catch((error) => {
					console.error('Failed to reschedule service call:', error);
					message.error('Failed to reschedule service call. Please try again.');
				});
		});
	};

	const handleRescheduleCancel = () => {
		setRescheduleModalVisible(false);
		setSelectedWorkOrder(null);
		setNewScheduledTime(null);
	};

	const draggableAccessor = (event) => {
		// Only allow dragging scheduled work orders
		return (
			event.eventStatus === 'Scheduled' ||
			event.eventStatus === 'PastDue' ||
			event.eventStatus === 'OnHold'
		);
	};

	const transformRecords = useMemo(() => {
		if (!data || data.length === 0) {
			return [];
		}
		return data.reduce((acc, workOrder) => {
			const lastServiceCall = nullSafeGet('lastServiceCall', workOrder);
			const serviceScheduledAt = nullSafeGet('serviceScheduledAt', lastServiceCall);

			if (!serviceScheduledAt) {
				return acc;
			}

			const checkInTime = nullSafeGet('checkInTime', lastServiceCall);
			const checkOutTime = nullSafeGet('checkOutTime', lastServiceCall);
			const displayStatus = nullSafeGet('displayStatus', workOrder);
			const status = nullSafeGet('status', workOrder);
			const dueDate = nullSafeGet('dueDate', workOrder);

			// Determine event status: Scheduled, PastDue, CheckedIn, OnHold, or Completed

			let eventStatus = 'Scheduled';

			if (
				displayStatus === WORK_ORDER_DISPLAY_STATUSES.hold ||
				status === WORK_ORDER_STATUSES.workIncompleteWithReason ||
				status === WORK_ORDER_STATUSES.workUnsatisfactory
			) {
				eventStatus = 'OnHold';
			} else if (displayStatus === WORK_ORDER_DISPLAY_STATUSES.complete) {
				eventStatus = 'Completed';
			} else if (displayStatus === WORK_ORDER_DISPLAY_STATUSES.pending) {
				eventStatus = 'Pending';
			} else if (checkInTime && !checkOutTime) {
				eventStatus = 'CheckedIn';
			} else if (displayStatus === 'Completed') {
				eventStatus = 'Completed';
			} else if (eventStatus === 'Scheduled' && dueDate && isDatePastDue(dueDate)) {
				eventStatus = 'PastDue';
			}

			const title = `${capitalize(nullSafeGetOrElse('title', workOrder, 'Scheduled'))}`;

			const startTime = checkInTime || serviceScheduledAt;
			const startMoment = moment(startTime);
			if (!startMoment.isValid()) {
				return acc;
			}
			const startDateObj = startMoment.toDate();

			let endDateObj;
			if (
				(eventStatus === 'CheckedIn' || eventStatus === 'Completed' || eventStatus === 'OnHold') &&
				checkOutTime
			) {
				const checkOutMoment = moment(checkOutTime);
				endDateObj = checkOutMoment.isValid()
					? checkOutMoment.toDate()
					: moment(startDateObj).add(1, 'hour').toDate();
			} else if (checkInTime && !checkOutTime) {
				endDateObj = moment().toDate();
			} else {
				endDateObj = moment(startDateObj).add(1, 'hour').toDate();
			}

			const event = {
				...workOrder,
				title,
				category: nullSafeGet('displayStatus', workOrder),
				eventStatus: eventStatus,
				start: startDateObj,
				end: endDateObj,
			};

			return acc.concat(event);
		}, []);
	}, [data]);

	const EventComponent = ({ event }) => {
		if (!event) {
			return null;
		}

		const workOrderId = nullSafeGet('id', event);
		const locationName = nullSafeGet('location.name', event);
		const title = nullSafeGet('title', event);

		return (
			<Popover
				trigger="click"
				placement="topLeft"
				overlayClassName="workOrderPopoverDisplay_wrapper"
				content={<ServiceCallPopoverDisplayV2 workOrder={event} />}
			>
				<div className="event-content-hover-wrapper flex h-full flex-col justify-start overflow-hidden border border-red-500 px-1">
					<div className="flex flex-row items-baseline gap-x-1">
						<span className="bodymedium text-character-primary">#{workOrderId}</span>
						{title && (
							<div className="event-title-multiline footnoteregular text-grey-8">{title}</div>
						)}
					</div>
					{locationName && (
						<div className="footnoteregular overflow-hidden text-ellipsis whitespace-nowrap text-character-primary">
							{locationName}
						</div>
					)}
				</div>
			</Popover>
		);
	};

	const isInternalTeam = useMemo(() => isInternalTech(currentUser), [currentUser]);

	const advancedFiltersConfig = useMemo(
		() =>
			isInternalTeam
				? INTERNAL_SERVICE_TEAM_WO_FILTERS_ORDER
				: isSupplierPayingCustomer(currentUser)
				? PAYING_SUPPLIER_WO_FILTER_ORDER
				: THIRD_PARTY_SUPPLIER_WO_FILTERS_ORDER,
		[currentUser, isInternalTeam]
	);

	const SUPPLIER_FILTER_CONFIG = useSupplierFilterConfiguration({
		fieldTechs,
		updateFilters,
		fetchFieldTechs,
		fetchMultipleFieldTechs,
		spendCategories,
		fetchSpendCategories,
		fetchMultipleSpendCategories,
		contractorPrivateNetworks,
		fetchContractors,
		currentUser,
		contractorClients,
		fetchContractorClients,
		fetchMultipleContractorClients,
		contractorLocations,
		fetchContractorLocations,
		fetchMultipleContractorLocations,
	});
	const COMMON_FILTER_CONFIGS = useCommonFilterConfiguration({
		locations,
		fetchLocations,
		areas,
		fetchAreasDistinct,
		workOrderPriorities,
		fetchWorkOrderPriorities,
		assets,
		fetchAssets,
		fetchMultipleAssets,
		assetTypes,
		fetchAssetTypes,
		fetchMultipleAssetTypes,
		planned_maintenance_schedules,
		fetchPMSchedule,
		fetchMultiplePMSchedule,
		problemTypes,
		fetchProblemTypes,
		currentUser,
		supplierFacilities,
		fetchSupplierFacilitiesInPrivateNetwork,
		resolutionTypes,
		fetchResolutionTypes,
		fetchMultipleResolutionTypes,
		staleDays,
		updateFilters,
		users,
		fetchUsers,
		fetchMultipleUsers,
	});

	const FILTER_CONFIG = useMemo(() => {
		const defaultConfig: any[] = [...COMMON_FILTER_CONFIGS, ...SUPPLIER_FILTER_CONFIG];

		const advancedFilterConfig =
			advancedFiltersConfig && advancedFiltersConfig.length > 0
				? advancedFiltersConfig.map((filter) => defaultConfig.find((_) => _.fieldName === filter))
				: defaultConfig;
		return advancedFilterConfig.filter(
			(_) =>
				!!_ &&
				_.fieldName !== FILTER_CONFIG_NAMES.LAST_SERVICE_CALL_SCHEDULED_AT &&
				_.fieldName !== FILTER_CONFIG_NAMES.TECHNICIAN
		);
	}, [advancedFiltersConfig, COMMON_FILTER_CONFIGS, SUPPLIER_FILTER_CONFIG]);

	const selectedTechnicianEmail = nullSafeGet('filters.fieldTechnicianEmail', workOrders);
	const selectedTechnician = useMemo(() => {
		if (!selectedTechnicianEmail || !fieldTechs) {
			return null;
		}
		// cant use getEntityById or nullsafeget here because email also has "." in it.
		const records = fieldTechs.records;
		if (records && records[selectedTechnicianEmail]) {
			return records[selectedTechnicianEmail];
		}
		return null;
	}, [selectedTechnicianEmail, fieldTechs]);

	const myTimeZone = useMemo(() => moment.tz.guess(), []);

	const customHeader = useCallback(
		({ counts, applySorting, sorters, pagination, applyFilters, filters }) => (
			<>
				<div className="flex flex-row items-start justify-between px-4 pt-4">
					<div className="flex flex-col items-start justify-start gap-y-2">
						<div className="flex flex-col flex-wrap items-start justify-start gap-3">
							<div className="h5medium text-character-primary">
								Schedule Work Orders {pagination.total ? `(${pagination.total})` : null}
							</div>
							{selectedTechnicianEmail || selectedTechnician ? (
								<div className="bodyregular text-grey-8">
									Showing work orders visible to{' '}
									<span className="font-medium">
										{nullSafeGet('name', selectedTechnician)
											? nullSafeGet('name', selectedTechnician)
											: selectedTechnicianEmail}
									</span>
								</div>
							) : null}
							<div className="flex flex-row flex-wrap items-center justify-start gap-2">
								<OWSearchInput
									key="schedule-work-orders-search"
									placeholder="Search "
									onChange={(value) => applyFilters({ search: value })}
									size="small"
									style={{ width: 150 }}
								/>
								<Sorter
									size="small"
									items={WORK_ORDER_SORTERS}
									value={sorters}
									onChange={applySorting}
								/>
							</div>
						</div>
					</div>
					<Button
						type="text"
						icon={<CloseOutlined />}
						onClick={() => setShowScheduleWOs((prev) => !prev)}
					/>
				</div>
				<Divider style={{ margin: '16px 0 0 0' }} />
			</>
		),
		[selectedTechnicianEmail, selectedTechnician]
	);

	useEffect(() => {
		setScrollToTime(moment().subtract(4, 'hour').toDate());
	}, []);

	useEffect(() => {
		if (!showScheduleWOs) {
			return;
		}

		const technicianEmail = nullSafeGet('filters.fieldTechnicianEmail', workOrders);

		if (syncScheduleTechnicianFilter) {
			syncScheduleTechnicianFilter({
				fieldTechnicianVisibilityEmail: technicianEmail || undefined,
			});
		}
	}, [workOrders, syncScheduleTechnicianFilter, showScheduleWOs]);

	// Memoize CustomWorkOrderRowDisplayProps to prevent unnecessary re-renders
	const customWorkOrderRowDisplayProps = useMemo(
		() => ({
			onRefreshTable: (scheduledTime) => {
				if (scheduledTime) {
					const scheduledMoment = moment(scheduledTime);
					if (scheduledMoment.isValid()) {
						const scheduledDate = scheduledMoment.toDate();
						setCalendarDate(scheduledDate);
						setScrollToTime(scheduledDate);
						updateDateFiltersForView(calendarView, scheduledDate);
					}
				} else {
					// If no scheduled time, just refresh the data
					fetchData(location, calendarDate, calendarView);
				}
			},
			leadTechnicianEmail: nullSafeGet('filters.fieldTechnicianEmail', workOrders),
			serviceScheduledAt: calendarView === Views.DAY ? moment() : null,
		}),
		[calendarView, calendarDate, updateDateFiltersForView, fetchData, location, workOrders]
	);

	// Memoize renderEmptyState callback
	const renderEmptyState = useCallback(() => <EmptyState headline="No open work orders" />, []);

	const scheduleWorkOrdersPreAppliedFilters = useMemo(() => {
		const baseFilters = {
			unscheduledOrPastSchedule: true,
			statuses: isInternalTeam
				? 'Unassigned,AssignedToInternalTech,TechCancelled,TechAssigned,TechScheduled,TechRescheduled,WorkIncompleteWithReason'
				: 'PendingConfirmationByServiceProvider,TechCancelled,PendingConfirmationByServiceProvider,TechAssigned,TechScheduled,TechRescheduled,WorkIncompleteWithReason',
		};
		const technicianEmail = nullSafeGet('filters.fieldTechnicianEmail', workOrders);
		if (technicianEmail) {
			return {
				...baseFilters,
				fieldTechnicianVisibilityEmail: technicianEmail,
			};
		}
		return baseFilters;
	}, [workOrders, isInternalTeam]);

	return (
		<Content className="supplierWorkOrdersIndexPage relative" style={{ padding: '0 0.5em' }}>
			{showScheduleWOs ? null : (
				<div
					className=" absolute left-[-7px]  top-1/2 z-10 mx-0 flex -translate-y-1/2 transform cursor-pointer flex-row items-center justify-center gap-1  bg-white px-1  py-3 font-medium tracking-wide text-supplier"
					style={{
						writingMode: 'sideways-lr',
						textOrientation: 'mixed',
						border: '1px solid var(--Grey-5, #D9D9D9)',
						position: 'absolute',
						transform: 'translateY(-50%)',
						borderRadius: '0 10px 10px 0px',
					}}
					onClick={() => setShowScheduleWOs(!showScheduleWOs)}
				>
					<span>Schedule Work Orders</span>
					<CaretDownFilled style={{ transform: 'rotate(270deg)' }} />
				</div>
			)}
			<Row key={2} style={{ margin: '1 -8px' }} gutter={[12, 12]}>
				<PipelineFilter
					items={pipelineFiltersSupplierCalendar()}
					subItems={morePipelineFiltersSupplier(false, isInternalTeam)}
					onChange={updateFilters}
					mode="multiple"
					value={nullSafeGetOrElse(`filters`, workOrders, {})}
					counts={nullSafeGetOrElse('counts', workOrders, {})}
				/>
				<Col span={24}>
					<SubnavBar
						left={
							<div className="flex flex-row flex-wrap items-center gap-3">
								<Filters
									filterConfig={FILTER_CONFIG}
									currentUser={currentUser}
									applyFilters={updateFilters}
									filters={nullSafeGetOrElse(`filters`, workOrders, {})}
									clearFilters={handleClearAndUpdateFilters}
									targetCollectionName={WORK_ORDERS_CALENDAR_TARGET_COLLECTION}
									userType={ROLE_TYPES.SUPPLIER}
									preAppliedFilters={nullSafeGetOrElse(`preAppliedFilters`, workOrders, {})}
									sorterItems={[]}
								/>

								<TechnicianFilter
									value={nullSafeGetOrElse(`filters`, workOrders, {})}
									onChange={updateFilters}
									fieldTechs={fieldTechs}
									fetchFieldTechs={fetchFieldTechs}
									fetchMultipleFieldTechs={fetchMultipleFieldTechs}
								/>

								<AssignedFilters
									items={ASSIGNED_FILTERS(currentUser).items}
									currentUser={currentUser}
									userType={ROLE_TYPES.SUPPLIER}
									value={nullSafeGetOrElse(`filters`, workOrders, {})}
									onChange={updateFilters}
									selector={ASSIGNED_FILTERS(currentUser).selector}
								/>

								<SubContractedFilters
									items={SUBCONTRACTED_FILTERS(currentUser).items}
									currentUser={currentUser}
									userType={ROLE_TYPES.SUPPLIER}
									value={nullSafeGetOrElse(`filters`, workOrders, {})}
									onChange={updateFilters}
									selector={SUBCONTRACTED_FILTERS(currentUser).selector}
								/>
							</div>
						}
						right={null}
					/>
				</Col>
				<Col span={24}>
					<div className="flex w-full flex-1 flex-row ">
						<SelectedFilters
							updateFilters={updateFilters}
							filterValues={nullSafeGetOrElse(`filters`, workOrders, {})}
							filterConfig={FILTER_CONFIG}
						/>
					</div>
				</Col>
			</Row>

			{pagination.total > pagination.pageSize ? (
				<div className="bodyregular  mt-3 flex  flex-1 flex-row rounded-sm bg-[#277083] px-4 py-2 text-white ">
					Too many work orders to display. Some results are hidden. Filter{' '}
					{nullSafeGet('filters.fieldTechnicianEmail', workOrders) ? '' : 'by technician'} to
					proceed
				</div>
			) : null}
			<Row key={3} style={{ margin: '16px -8px' }} gutter={16} align="stretch" className="relative">
				{showScheduleWOs ? (
					<Col span={8} className="animate-slideInFromLeft">
						<Card
							style={{
								minHeight: 560,
								maxHeight: '100vh',
								padding: 0,
								height: '100%',
								display: 'flex',
								flexDirection: 'column',
							}}
							bodyStyle={{
								padding: 0,
								flex: 1,
								display: 'flex',
								flexDirection: 'column',
								overflow: 'scroll',
							}}
						>
							<WorkOrderTable
								ignoreRefreshCounts={true}
								handleQueryParams={false}
								preAppliedFilters={scheduleWorkOrdersPreAppliedFilters}
								CustomHeader={customHeader}
								CustomWorkOrderRowDisplay={ServiceCalendarWorkOrderRow}
								CustomWorkOrderRowDisplayProps={customWorkOrderRowDisplayProps}
								renderEmptyState={renderEmptyState}
								targetCollectionName={WORK_ORDERS_SCHEDULE_TARGET_COLLECTION}
							/>
						</Card>
					</Col>
				) : null}

				<Col span={showScheduleWOs ? 16 : 24}>
					<Card
						style={{
							minHeight: 560,
							maxHeight: '100vh',
							height: '100%',
							display: 'flex',
							flexDirection: 'column',
							position: 'relative',
							marginLeft: showScheduleWOs ? 0 : '34px',
						}}
						bodyStyle={{
							padding: '0 16px',
							flex: 1,
							display: 'flex',
							flexDirection: 'column',
							overflow: 'scroll',
							position: 'relative',
						}}
					>
						{fetching && (
							<div className="absolute inset-0 z-10 flex items-center justify-center bg-white bg-opacity-80">
								<Spin size="large" />
							</div>
						)}
						<EventCalendar
							events={transformRecords}
							date={calendarDate}
							view={calendarView}
							defaultView={Views.DAY}
							scrollToTime={scrollToTime}
							onRangeChange={handleRangeChange}
							onNavigate={(date) => setCalendarDate(date)}
							onView={(view) => {
								setCalendarView(view);
								// Update filters when view changes
								updateDateFiltersForView(view, calendarDate);
							}}
							views={{
								week: true,
								day: true,
								four_day_week: FourDayWeekView,
							}}
							components={{
								event: EventComponent,
							}}
							onEventDrop={handleEventDrop}
							draggableAccessor={draggableAccessor}
							step={15}
							timeslots={4}
						/>
					</Card>
				</Col>
			</Row>
			{rescheduleModalVisible && selectedWorkOrder && (
				<ScheduleServiceCallModalForm
					wrappedComponentRef={(ref) => {
						rescheduleFormRef.current = ref;
					}}
					formData={{
						...nullSafeGetOrElse('lastServiceCall', selectedWorkOrder, {}),
						workOrder: selectedWorkOrder,
						serviceScheduledAt: newScheduledTime
							? moment(newScheduledTime)
							: nullSafeGet(
									'serviceScheduledAt',
									nullSafeGetOrElse('lastServiceCall', selectedWorkOrder, {})
							  )
							? moment(
									nullSafeGet(
										'serviceScheduledAt',
										nullSafeGetOrElse('lastServiceCall', selectedWorkOrder, {})
									)
							  )
							: undefined,
					}}
					isReschedule={true}
					visible={rescheduleModalVisible}
					onCancel={handleRescheduleCancel}
					onSubmit={handleRescheduleSubmit}
					initialTimeZone={myTimeZone}
				/>
			)}
		</Content>
	);
};

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	location: ownProps.location,
	workOrders: state.work_orders[WORK_ORDERS_CALENDAR_TARGET_COLLECTION] || {},
	data: getEntitiesByIdWithSearch(
		state.work_orders[WORK_ORDERS_CALENDAR_TARGET_COLLECTION]
			? state.work_orders[WORK_ORDERS_CALENDAR_TARGET_COLLECTION].recordsIds || []
			: [],
		state.work_orders
	),
	fetching: state.work_orders[WORK_ORDERS_CALENDAR_TARGET_COLLECTION]
		? state.work_orders[WORK_ORDERS_CALENDAR_TARGET_COLLECTION].fetching
		: false,
	locations: state.locations,
	workOrderPriorities: state.work_order_priorities,
	fieldTechs: state.field_techs,
	assetTypes: state.asset_types,
	assets: state.assets,
	contractorPrivateNetworks: state.contractor_private_networks,
	spendCategories: state.spend_categories,
	problemTypes: state.problem_types,
	regions: state.regions,
	areas: state.areas,
	resolutionTypes: state.resolution_types,
	supplierFacilities: state.supplier_facilities,
	planned_maintenance_schedules: state.planned_maintenance_schedules,
	contractorClients: state.contractor_clients,
	contractorLocations: state.contractor_locations,
	users: state.all_contacts,
	brands: state.brands,
	companyConfig: state.company_config,
});

const mapDispatchToProps = (dispatch, ownProps) => {
	const startDateFieldName = getStartDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);
	const endDateFieldName = getEndDateFieldName(LAST_SERVICE_CALL_SCHEDULED_AT_FIELD);

	return {
		fetchData: (location, date, view) => {
			// Use provided date/view, or fall back to current day/DAY view
			const selectedDate = date || new Date();
			const selectedView = view || Views.DAY;
			const { startDate, endDate } = calculateDateRangeForView(selectedView, selectedDate);

			return dispatch(
				fetchWorkOrders(ROLE_TYPES.SUPPLIER)(
					true, // handleQueryParams
					ownProps.history,
					location,
					WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					{
						[startDateFieldName]: startDate,
						[endDateFieldName]: endDate,
						[getWorkOrderArchivalKey(ownProps.currentUser)]: false,
					},
					{ current: 1, pageSize: 100 },
					ownProps.initialSorting,
					ownProps.initialFilters,
					false
				)
			);
		},
		updateFilters: (filters) =>
			dispatch(
				updateFiltersWorkOrders(ROLE_TYPES.SUPPLIER)(
					true, // handleQueryParams
					ownProps.history,
					WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					filters,
					false // ignoreRefreshCounts
				)
			),
		clearFilters: (preserveFilters) =>
			dispatch(
				clearFiltersWorkOrders(ROLE_TYPES.SUPPLIER)(
					true, // handleQueryParams
					ownProps.history,
					WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					preserveFilters,
					false // ignoreRefreshCounts
				)
			),
		fetchMultipleWorkOrderPriorities: (ids, targetCollectionName) =>
			dispatch(
				workOrderPrioritiesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
			),
		fetchWorkOrderPriorities: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				workOrderPrioritiesRestCrudThunksForSupplier.read(
					params,
					targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchAssetTypes: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				assetTypesRestCrudThunksForSupplier.readLite(
					{ ...params, no_pagination: true },
					targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultipleAssetTypes: (ids, targetCollectionName) =>
			dispatch(assetTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
		fetchMultipleResolutionTypes: (ids, targetCollectionName) =>
			dispatch(resolutionTypesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
		fetchResolutionTypes: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				resolutionTypesRestCrudThunksForSupplier.read(
					params,
					targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchProblemTypes: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				problemTypesHeirarchicalForSupplier(
					params,
					targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchSupplierFacilitiesInPrivateNetwork: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				fetchSupplierFacilitiesInPrivateNetworkForSupplier(
					params,
					targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchPMSchedule: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				plannedMaintenanceSchedulesRestCrudThunksForSupplier.read(
					params,
					targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultiplePMSchedule: (ids, targetCollectionName) =>
			dispatch(
				plannedMaintenanceSchedulesRestCrudThunksForSupplier.readMultiple(
					ids,
					targetCollectionName || WORK_ORDERS_CALENDAR_TARGET_COLLECTION
				)
			),
		fetchMultipleFieldTechs: (ids, targetCollectionName) =>
			dispatch(fieldTechsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
		fetchFieldTechs: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				fieldTechsRestCrudThunksForSupplier.read(
					params,
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchSpendCategories: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				spendCategoriesRestCrudThunksForSupplier.read(
					params,
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultipleSpendCategories: (ids, targetCollectionName) =>
			dispatch(spendCategoriesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
		fetchAssets: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				assetsRestCrudThunksForSupplier.readLite(
					{ ...params },
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultipleAssets: (ids, targetCollectionName) =>
			dispatch(assetsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
		fetchContractors: (params, targetCollectionName) =>
			dispatch(
				ContractorPrivateNetworksRestCrudThunksForSupplier.read(params, targetCollectionName)
			),
		fetchAreasDistinct: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				fetchDistinctAreasHeirarchy(ownProps.userType)(
					{ ...params, no_pagination: true },
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),

		fetchContractorClients: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				contractorClientsRestCrudThunksForSupplier.read(
					{ ...params },
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultipleContractorClients: (ids, targetCollectionName) =>
			dispatch(contractorClientsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
		fetchContractorLocations: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				contractorLocationsRestCrudThunksForSupplier.read(
					{ ...params },
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultipleContractorLocations: (ids, targetCollectionName) =>
			dispatch(
				contractorLocationsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
			),
		fetchUsers: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				contactsRestCrudThunksForSupplierForThirdPartySuppliers.read(
					params,
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultipleUsers: (emails, targetCollectionName) =>
			dispatch(
				contactsRestCrudThunksForSupplierForThirdPartySuppliers.read(
					{ emails },
					targetCollectionName
				)
			),
		fetchBrands: (
			params,
			targetCollectionName,
			pagination,
			sorting,
			filters,
			addToTargetCollection
		) =>
			dispatch(
				brandsRestCrudThunksForSupplier.read(
					params,
					targetCollectionName,
					pagination,
					sorting,
					filters,
					addToTargetCollection
				)
			),
		fetchMultipleBrands: (ids, targetCollectionName) =>
			dispatch(brandsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
		fetchBrandsCount: (params) => dispatch(brandsRestCrudThunksForSupplier.countBy(params, 'all')),
		rescheduleServiceCall: (serviceCall) => dispatch(rescheduleServiceCallForSupplier(serviceCall)),
		getFullWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForSupplier.readOne(id)),
		syncScheduleTechnicianFilter: (filters) =>
			dispatch(
				updateFiltersWorkOrders(ROLE_TYPES.SUPPLIER)(
					false, // handleQueryParams
					ownProps.history,
					WORK_ORDERS_SCHEDULE_TARGET_COLLECTION,
					filters,
					true // ignoreRefreshCounts for schedule table
				)
			),
	};
};

export default withRouter(
	withUserType(
		withCurrentUser(
			connect(mapStateToProps, mapDispatchToProps)(SupplierServiceCallCalendarPageV2 as any)
		)
	)
);
